export enum WEATHER_ICONS {
    '01d' = 'icon-gz-sun',
    '02d' = 'icon-gz-cloud-sun',
    '03d' = 'icon-gz-cloud',
    '04d' = 'icon-gz-clouds',
    '09d' = 'icon-gz-rain',
    '10d' = 'icon-gz-rain',
    '11d' = 'icon-gz-clouds-flash-alt',
    '13d' = 'icon-gz-snow-heavy',
    '50d' = 'icon-gz-mist',
    '01n' = 'icon-gz-moon',
    '02n' = 'icon-gz-cloud-moon',
    '03n' = 'icon-gz-cloud',
    '04n' = 'icon-gz-clouds',
    '09n' = 'icon-gz-rain',
    '10n' = 'icon-gz-rain',
    '11n' = 'icon-gz-clouds-flash-alt',
    '13n' = 'icon-gz-snow-heavy',
    '50n' = 'icon-gz-mist',
    'na' =  'icon-gz-na'
}


// WEBPACK FOOTER //
// ./src/providers/weather/weather.enum.ts